export default "/_next/static/images/924a2ac153b0b5948745571d90918b67.png";